export default {
  data() {
    return {
      model: {},
    };
  },
  methods: {
    changed() {
      this.$emit('changed', this.model);
    },
    reset: () => {
      throw new Error('You must provide a proper reset fn.');
    },
  },
};
